import styled from '@emotion/styled';
import moment from 'moment';
import React from 'react';
import { InstitutionSummary } from '../../../ReduxStorage/Institutions/types';
import {
  ROUTE_INSTITUTION_HOMEPAGE,
  ROUTE_USER_PROFILE_PAGE,
} from '../../../ReduxStorage/routeActions';
import { UserSummary } from '../../../ReduxStorage/Users/constants';
import {
  UserIcon,
  UserRow,
} from '../../containers/SubscriptionsAdmin/ManageUsers/styles';
import { ActionPromiseButton } from '../Buttons/ActionButton/ActionPromiseButton';
import { RouteLink } from '../RouteLink/component';
import { OL_COLOUR_BLACK_10 } from '../Style/colours';

const Container = styled('div')({
  border: `solid 1px ${OL_COLOUR_BLACK_10}`,
  borderRadius: 4,
  padding: 2,
  marginTop: 8,
  width: '100%',

  table: {
    width: '100%',
  },

  tr: {
    borderBottom: `solid 1px ${OL_COLOUR_BLACK_10}`,

    'td:first-child': {
      borderRight: `solid 1px ${OL_COLOUR_BLACK_10}`,
    },
  },

  'tr:last-child': {
    borderBottom: 'none',
  },
});

const TableCell = styled('td')({
  padding: 16,
});

const HeaderCell = styled(TableCell)({
  fontWeight: 'bold',
});

export type InstitutionsAdminTableProps = {
  profileName: string;
  institutions: InstitutionSummary[];
  owners: UserSummary[];
  onAddAdmin: (institutionId: string) => Promise<void>;
};

export const InstitutionsAdminTable = React.memo(
  ({
    profileName,
    institutions,
    owners,
    onAddAdmin,
  }: InstitutionsAdminTableProps) => (
    <Container>
      <table>
        <tr>
          <HeaderCell>Institutions</HeaderCell>
          <HeaderCell>Created by</HeaderCell>
          <HeaderCell>Created date</HeaderCell>
          <HeaderCell>Action</HeaderCell>
        </tr>
        {institutions.map((institution) => {
          const owner = owners.find(
            (owner) => owner.id === institution.createdBy
          );
          return (
            <tr>
              <TableCell>
                <RouteLink
                  to={{
                    type: ROUTE_INSTITUTION_HOMEPAGE,
                    state: {
                      institutionPrefix: institution.path,
                    },
                  }}
                >
                  {institution.name}
                </RouteLink>
              </TableCell>
              <TableCell>
                {owner && (
                  <UserRow>
                    <UserIcon src={owner.smallAvatar} />
                    <RouteLink
                      to={{
                        type: ROUTE_USER_PROFILE_PAGE,
                        params: {
                          profileName: owner.profileName,
                        },
                      }}
                    >
                      {owner.fullName}
                    </RouteLink>
                  </UserRow>
                )}
              </TableCell>
              <TableCell>
                {moment(institution.createdOn).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell>
                {institution.admins.some((admin) => admin === profileName) ? (
                  'Already institution admin'
                ) : (
                  <ActionPromiseButton
                    colour="kelp"
                    label="Join as institution admin"
                    onClick={() => onAddAdmin(institution.id)}
                  />
                )}
              </TableCell>
            </tr>
          );
        })}
      </table>
    </Container>
  )
);
